var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies, Layout, Auth } from '~/core/decorator';
import { Getter, namespace, State } from 'vuex-class';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import SelectDepartment from "~/components/business-component/select-department.vue";
import NumberRange from '~/components/common/number-range.vue';
import { LegalCaseManageService } from '~/services/domain-service/legal-case-manage.service';
import Apply from '~/components/visit-case/apply.vue';
import { ApplyType, CASE_CHANNEL, MENU_CHANNEL } from '~/config/enum.config';
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import PrincipalRecovery from "~/components/apply-component/principal-recovery.vue";
var CollectionExecutionModule = namespace('collection-execution');
var LegalRecoverCaseManage = /** @class */ (function (_super) {
    __extends(LegalRecoverCaseManage, _super);
    function LegalRecoverCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            compensationMoney: {
                max: "",
                min: ""
            },
            overdueDays: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            deptIds: [],
            currentCollectorRealName: '',
            recordFollowInTime: [],
            partnerName: '',
            batchNumber: ''
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.dialog = {
            apply: false,
            principalRecovery: false
        };
        _this.caseChannel = CASE_CHANNEL.legal;
        _this.applyType = {};
        return _this;
    }
    LegalRecoverCaseManage.prototype.created = function () {
        this.refreshData();
    };
    LegalRecoverCaseManage.prototype.refreshData = function () {
        var _this = this;
        this.legallyCaseManageServiceTestE
            .recoverCasePool(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    LegalRecoverCaseManage.prototype.departemntChange = function (id, code) { };
    LegalRecoverCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.deptId = this.model.deptIds.length ? this.model.deptIds[this.model.deptIds.length - 1] : '';
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        params.recordFollowInTimeMin = this.model.recordFollowInTime.length ? this.$filter.dateTimeFormat(this.model.recordFollowInTime[0]) : '';
        params.recordFollowInTimeMax = this.model.recordFollowInTime.length ? this.$filter.dateTimeFormat(this.model.recordFollowInTime[1]) : '';
        params.compensationMoneyMax = this.model.compensationMoney ? this.model.compensationMoney.max : "";
        params.compensationMoneyMin = this.model.compensationMoney ? this.model.compensationMoney.min : "";
        params.overdueDaysMax = this.model.overdueDays ? this.model.overdueDays.max : "";
        params.overdueDaysMin = this.model.overdueDays ? this.model.overdueDays.min : "";
        delete params.compensationMoney;
        delete params.overdueDays;
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionDays;
        delete params.followInTime;
        delete params.loanDate;
        delete params.recordFollowInTime;
        delete params.deptIds;
        return params;
    };
    /**
     * 表单范围输入框重置
     */
    LegalRecoverCaseManage.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: "", max: "" };
        this.model.personalCollectionRemainingDays = { min: "", max: "" };
        this.model.compensationMoney = { min: "", max: "" };
        this.model.overdueDays = { min: "", max: "" };
    };
    /**
     * 提前流转
     */
    LegalRecoverCaseManage.prototype.advanceCirculation = function () {
        if (this.selectionList.length === 0) {
            this.$message.info('请选择要流转的案件');
            return;
        }
        this.applyType = ApplyType.turn;
        this.dialog.apply = true;
    };
    /**
     *
     */
    LegalRecoverCaseManage.prototype.moveToWaitDistribution = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$message.info('请选择要回收的案件');
            return;
        }
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5C06\u5DF2\u9009\u62E9\u7684\u6848\u4EF6\u79FB\u5165\u7535\u50AC\u5F85\u5206\u914D\u5417?", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            _this.legallyCaseManageServiceTestE
                .moveToWaitDistribution({
                ids: _this.selectionList.map(function (v) { return v.id; }),
            })
                .subscribe(function (data) {
                _this.$message.success('操作成功');
                _this.refreshData();
            });
        });
    };
    Object.defineProperty(LegalRecoverCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 进入查看执行页
     */
    LegalRecoverCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Legal_recover,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 委托方回收
     */
    LegalRecoverCaseManage.prototype.dealManualPartReturnCase = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.principalRecovery = true;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u8FDB\u884C\u59D4\u6258\u65B9\u56DE\u6536\u7684\u6848\u4EF6");
        }
    };
    __decorate([
        Dependencies(PageService)
    ], LegalRecoverCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LegalRecoverCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], LegalRecoverCaseManage.prototype, "legallyCaseManageServiceTestE", void 0);
    __decorate([
        Getter
    ], LegalRecoverCaseManage.prototype, "callDepartmentData", void 0);
    __decorate([
        State
    ], LegalRecoverCaseManage.prototype, "principalList", void 0);
    LegalRecoverCaseManage = __decorate([
        Auth(306),
        Layout('workspace'),
        Component({
            components: {
                NumberRange: NumberRange,
                Apply: Apply,
                GetLabelName: GetLabelName,
                SelectDepartment: SelectDepartment,
                PrincipalRecovery: PrincipalRecovery
            },
        })
    ], LegalRecoverCaseManage);
    return LegalRecoverCaseManage;
}(Vue));
export default LegalRecoverCaseManage;
